"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const debug = debug_1.default('report-error');
class ErrorReporter {
    constructor(sendErrorDelegate) {
        this.sendErrorDelegate = sendErrorDelegate;
    }
    sendFatalError(message, ...details) {
        this.sendNonFatalError(message, ...details);
    }
    sendNonFatalError(message, ...details) {
        console.error(message, details);
        this.reportError(message, details);
    }
    sendFatalException(err, ...details) {
        this.sendNonFatalException(err, ...details);
    }
    sendNonFatalException(err, ...details) {
        if (err instanceof Error) {
            console.error(err.message, err);
        }
        else {
            console.error(err);
        }
        this.reportError(err, details);
    }
    reportError(error, details) {
        let extra = details;
        try {
            extra = JSON.stringify(details);
        }
        catch (err) {
            debug('could not serialize details to string, using array', err, details);
        }
        debug('sending error report', error, extra);
        const sendErrorDetails = {
            error,
            extra: { details: extra }
        };
        this.sendErrorDelegate(sendErrorDetails);
    }
}
exports.ErrorReporter = ErrorReporter;
//# sourceMappingURL=error-reporter.js.map